module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"header":{"accessLink":"Odkaz"}},"de":{"header":{"once":"Einzelübermittlung","accessLink":"Zugangslink"}},"es":{"header":{"once":"Envío único","accessLink":"Enlace de acceso"}},"fr":{"header":{"once":"Soumission unique","accessLink":"Lien d\u0027accès"}}}')
  delete Component.options._Ctor
}
